<template>
  <v-container fluid class="academic">
    <v-data-table
      id="scollStyle"
      ref="academic_list"
      :headers="headers"
      :items="academics"
      :sort-desc="[false, true]"
      multi-sort
      class="elevation-0"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>My Qualifications</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="academic--button"
            link
            @click="newRecord"
          >
            <v-icon class="mx-2"> add </v-icon>
            Add Qualification
          </v-btn>
        </v-toolbar>
        <AcademicsDialog
          :levels="levels"
          :certifications="certifications"
          :dialogbox="academicsDialog"
          @setAcademicsDialog="setAcademicsDialog"
          :isEdit="editModal"
          :updateAttachment="updateFile"
        />
        <policy-dialog
          :policyDialog="policyDialog"
          v-on:close-dialog="closeDialog"
        />
      </template>
      <!--eslint-disable-next-line -->
        <template v-slot:item.base64Attachment="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              x-large
              :disabled="item.base64Attachment.length === 0"
              color="indigo"
              v-bind="attrs"
              v-on="on"
              @click="download(item)"
            >
              <v-icon>download_for_offline</v-icon>
            </v-btn>
          </template>
          <span>Download Attachment</span>
        </v-tooltip>
      </template>
      <!--eslint-disable-next-line -->
        <template v-slot:item.actions="{ item }">
        <div class="d-flex justify-start">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                color="blue lighten-4"
                label
                v-bind="attrs"
                v-on="on"
                link
                class="mx-1"
                @click="openModal(item.lineNo)"
              >
                <v-icon color="blue darken-4">mode_edit</v-icon>
              </v-chip>
            </template>
            <span>Edit Academics</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                color="red lighten-4"
                label
                v-bind="attrs"
                v-on="on"
                @click="deleteacademic(item)"
                class="mx-1"
              >
                <v-icon color="red darken-4">delete</v-icon>
              </v-chip>
            </template>
            <span>delete Qualification</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import helpers from "../../dashboard/utils/helpers/helper.js";
import AcademicsDialog from "../components/academicsDialog.vue";
import policyDialog from "./policyDialog.vue";
export default {
  name: "academicsList",
  components: { AcademicsDialog, policyDialog },
  data: function () {
    return {
      academicsDialog: false,
      policyDialog: true,
      editModal: true,
      updateFile: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Profile/getProfile");
    });
  },
  computed: {
    academics() {
      return this.$store.getters["Profile/academicsGetters"]("academics");
    },
    levels() {
      return this.$store.getters["Profile/setupGetter"]("levels");
    },
    certifications() {
      return this.$store.getters["Profile/setupGetter"]("certificationCodes");
    },
    headers() {
      return [
        {
          text: "#no",
          align: "start",
          sortable: false,
          value: "lineNo",
        },
        {
          text: "Institution",
          sortable: true,
          value: "institution",
        },
        { text: "Level", sortable: true, value: "levels" },
        { text: "Certification", sortable: true, value: "certificateAwarded" },
        {
          text: "Course Title",
          sortable: true,
          value: "areaOfSpecialization",
        },
        { text: "Grade", sortable: true, value: "grade" },
        { text: "Attachment", sortable: true, value: "base64Attachment" },
        { text: "Actions", sortable: false, value: "actions" },
      ];
    },
  },
  methods: {
    newRecord() {
      this.academicsDialog = true;
      this.editModal = false;
      this.updateFile = false;
    },
    setAcademicsDialog: function (value) {
      this.academicsDialog = value;
    },
    setPolicyDialog: function (value) {
      this.policyDialog = value;
    },
    openModal(data) {
      this.editModal = true;
      this.updateFile = true;
      this.$store.dispatch("Profile/getacademics", {
        lineNo: data.toString(),
      });
    },
    deleteacademic(data) {
      this.$confirm.show({
        title: "Remove this Qualification?",
        text: `Are you sure you want to remove?`,
        onConfirm: () => {
          delete data.base64Attachment;
          this.$store.dispatch("Profile/deleteacademics", { ...data });
        },
      });
    },
    download(item) {
      const a = document.createElement("a");
      a.href = `data:${helpers.detectMimeType(item.base64Attachment)};base64,${
        item.base64Attachment
      }`;
      a.download = `${item.profileID}_academics_${
        item.lineNo
      }${helpers.fileExtension(item.base64Attachment)}`;
      a.click();
    },
    closeDialog: function (val) {
      this.policyDialog = val;
    },
  },
};
</script>

<style scoped>
/* @import url("./styles.css"); */
</style>
